import { createSelector } from 'reselect';

const selectPayouts = (state: any) => state.payouts;


export const selectCurrentItem = createSelector([selectPayouts], (payouts) => payouts.current);

export const selectListItems = createSelector([selectPayouts], (payouts) => payouts.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectPayouts], (payouts) => payouts.create);

export const selectUpdatedItem = createSelector([selectPayouts], (payouts) => payouts.update);

export const selectReadItem = createSelector([selectPayouts], (payouts) => payouts.read);

export const selectDeletedItem = createSelector([selectPayouts], (payouts) => payouts.delete);

export const selectSearchedItems = createSelector([selectPayouts], (payouts) => payouts.search);

export const selectItemsCount = createSelector([selectPayouts], (payouts) => payouts.count);

export const selectItemsFilter = createSelector([selectPayouts], (payouts) => payouts.filter);